import React, {useEffect, useState} from "react";
import AsyncSelect from 'react-select/async';
import {Form} from "react-bootstrap";
import {genericSelectGetAll} from "../pages/generic/crud";

export function AGCSelect({entityId, formik, isMulti, name, toolTip = "", value,
                              id, forUpdate = false, required = true, showAll = false, showAllText = "All"}) {
    const [dataList, setDataList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');

    if (toolTip === "") {
        toolTip = "Select " + name;
    }

    useEffect(() => {
        genericSelectGetAll(entityId).then(({data}) => {
            // Normalize data to use id/name format (API may return value/label)
            let normalizedData = data.map(item => ({
                id: item.id || item.value,
                name: item.name || item.label
            }));

            if (showAll) {
                normalizedData = [{id: 9999, name: showAllText}, ...normalizedData];
            }

            setDataList(normalizedData);
        }).catch(() => {
            setIsLoading(false);
        });
    }, [entityId]);

    const loadOptions = (inputValue, callback) => {
        const filteredOptions = dataList.filter(option =>
            option.name?.toLowerCase().includes(inputValue.toLowerCase())
        );

        callback(filteredOptions);
    };

    return (
        <>
            <Form.Label className={required ? 'required' : ''}>{name}</Form.Label>
            <AsyncSelect
                key={`${entityId}-${dataList.length}`}
                isMulti={isMulti}
                defaultOptions={dataList}
                value={value}
                getOptionLabel={(option) => option.name || option.label}
                getOptionValue={(option) => option.id || option.value}
                inputValue={inputValue}
                onInputChange={setInputValue}
                loadOptions={loadOptions}
                isDisabled={forUpdate}
                onChange={option => formik.setFieldValue(id, option)}
            />
            <Form.Text className="text-muted">{toolTip}</Form.Text>
        </>
    );
}
